define(function(){
  var Backbone = require('backbone');
  const IpsModelCollection = require('civicsBase/ipsModelCollection');
  const FeatureModel = require('civicsModels/portal/feature_model');
  return IpsModelCollection.extend({
    model: FeatureModel,
    urlRoot: '/delegate/civics-api/api/portal/features',
    url:function(){
      return this.urlRoot;
    },
    parse: function(response) {
      this.responseStatus = response.responseStatus;
      return response.data;
    }
  });
});
